export default __webpack_public_path__ + "static/media/search.94b5c9fa.svg";